import md5 from "md5";

export interface IElitrackProps {
  categoryId?: string;
  productDescription?: string;
  productId?: string;
  productPrice?: number;
  productCategoryIds?: Array<string | undefined>;
  checkoutProductTab?: string;
  checkoutTotalPrice?: number;
  checkoutCurrency?: string;
  orderConfirmationProductTab?: string;
  orderConfirmationTotalPrice?: number;
  orderConfirmationShippingPrice?: number;
  orderConfirmationReference?: string;
  orderConfirmationCustomerType?: number;
  orderConfirmationCheckoutCurrency?: string;
  orderConfirmationDiscountCode?: string;
  orderConfirmationDiscountAmount?: number;
}

const elitrackTag = (
  pageType?: string,
  elitrackProps?: IElitrackProps,
  email?: string
): string => {
  const ELITRACK_CLIENT_PUBLIC_KEY = "e78f10150bcf2a3c81c4e4135539126b";
  const CUSTOMER_HASH = md5(email || "");

  const BASE_URL =
    ("https:" === document.location.protocol ? "https" : "http") +
    "://tck.elitrack.com/tag?page=";
  const PARAMS = `aid=${ELITRACK_CLIENT_PUBLIC_KEY}&cid=${CUSTOMER_HASH}`;
  let src;

  if (pageType === "homepage") {
    src = `${BASE_URL}home&${PARAMS}`;
  } else if (pageType === "category") {
    const CATEGORY_DESCRIPTION = undefined;
    const CATEGORY_ID = elitrackProps?.categoryId;

    src = `${BASE_URL}category&${PARAMS}&catId=${CATEGORY_ID}&catDescription=${CATEGORY_DESCRIPTION}`;
  } else if (pageType === "product") {
    const PRODUCT_DESCRIPTION = elitrackProps?.productDescription;
    const PRODUCT_ID = elitrackProps?.productId;
    const PRODUCT_PRICE = elitrackProps?.productPrice;
    const CATEGORY_IDS = elitrackProps?.productCategoryIds;

    src = `${BASE_URL}product&${PARAMS}&prodId=${PRODUCT_ID}&prodDescription=${PRODUCT_DESCRIPTION}&prodPrice=${PRODUCT_PRICE}&catIds=${CATEGORY_IDS}`;
  } else if (pageType === "checkout") {
    const PRODUCT_TAB = elitrackProps?.checkoutProductTab;
    const TOTAL_PRICE = elitrackProps?.checkoutTotalPrice;
    const CURRENCY = elitrackProps?.checkoutCurrency;

    src = `${BASE_URL}cart&${PARAMS}&products=${PRODUCT_TAB}&totalPrice=${TOTAL_PRICE}&currency=${CURRENCY}`;
  } else if (pageType === "orderConfirmation") {
    const PRODUCT_TAB = elitrackProps?.orderConfirmationProductTab;
    const TOTAL_PRICE = elitrackProps?.orderConfirmationTotalPrice;
    const CURRENCY = elitrackProps?.orderConfirmationCheckoutCurrency;
    const SHIPPING_PRICE = elitrackProps?.orderConfirmationShippingPrice;
    const REFERENCE = elitrackProps?.orderConfirmationReference;
    const CUSTOMER_TYPE = elitrackProps?.orderConfirmationCustomerType;
    const DISCOUNT_AMOUNT = elitrackProps?.orderConfirmationDiscountAmount;
    const DISCOUNT_CODE = elitrackProps?.orderConfirmationDiscountCode;

    src = `://tck.elitrack.com/track?${PARAMS}&products=${PRODUCT_TAB}&totalPrice=${TOTAL_PRICE}&shippingPrice=${SHIPPING_PRICE}&reference=${REFERENCE}&new=${CUSTOMER_TYPE}&currency=${CURRENCY}&discountCode=${DISCOUNT_CODE}&discountAmount=${DISCOUNT_AMOUNT}`;
  } else {
    src = `${BASE_URL}other&${PARAMS}`;
  }

  return src;
};

export default elitrackTag;
